import { ArrowRightIcon, CheckIcon, StarIcon, UsersIcon } from "lucide-react";
import { capitalizeWords } from "../../utilities/utils";
import SuccessStory from "../../components/SuccessStory";
import { selectOnboardingUserDetails } from "../../redux/onboardingUserDetails";
import { useSelector } from "react-redux";
import { ClipLoader } from "react-spinners";

const benefits = [
  "A Standout Portfolio With A 93% Better CV",
  "3x Higher Chance Of Getting Hired With Amazing Skills",
  "Certificate Recognised By 1,100+ Top Companies",
];

// const courseOutcomes = [
//   "Hands-off Experience of Figma",
//   "Developer Functioning Micro Animations",
//   "Hands-off Experience of Figma",
//   "Hands-off Experience of Figma",
// ];

const DesktopOnboardingOverview = ({ courseModule, lessonIndex , completedLessons, handleUnlock , isModalLoading }) => {
  const onboardingUserDetails = useSelector(selectOnboardingUserDetails)
  return (
    <div className="bg-[#102D47] px-4 py-[76px]">
        <div className="flex flex-col items-start gap-8 rounded-[16px] border border-white/10 bg-gradient-to-b from-[#17395A] to-[#102D47] p-4">
        <div className="inline-flex items-center gap-2 px-3 py-2 bg-[#2bbd131a] text-[#2bbd13] rounded-[20px]">
            <CheckIcon className="w-4 h-4" />
            <span className="[font-family:'Inter',Helvetica] font-semibold text-sm tracking-[0] leading-[14px]">
            {completedLessons} {completedLessons === 1 ? 'Lesson' : 'Lessons'} Completed
            </span>
        </div>

        <section className="flex flex-col items-start gap-6 w-full">
            <div className="flex flex-col items-start gap-3 w-full">
            <h1 className="[font-family:'Inter',Helvetica] font-bold text-white text-[28px] tracking-[0] leading-[35px]">
                You&apos;re Making Great Progress, {capitalizeWords(onboardingUserDetails?.name)}!
            </h1>

            <p className="[font-family:'Inter',Helvetica] font-normal text-base tracking-[0] leading-[22.4px]">
                <span className="text-[#ffffffb2]">Get certified in </span>
                <span className="font-bold text-white">{capitalizeWords(courseModule?.course_name)}</span>
                <span className="text-[#ffffffb2]">
                {" "}
                by unlocking full course access.
                </span>
            </p>
            </div>

            <div className="flex items-center gap-2 w-full">
            <div className="inline-flex items-center gap-1">
                <span className="[font-family:'Inter',Helvetica] font-bold text-[#2bbd13] text-[28px] leading-7 tracking-[0]">
                ₹399
                </span>
                <span className="[font-family:'Inter',Helvetica] font-normal text-[#e06064] text-sm leading-[14px] line-through tracking-[0]">
                ₹999
                </span>
            </div>
            <span className="flex-1 [font-family:'Inter',Helvetica] font-normal italic text-white text-xs tracking-[0] leading-[16.8px]">
                (Limited-time pricing for active learners)
            </span>
            </div>

            <div className="flex flex-col items-start gap-3 w-full">
            <button className="flex h-[52px] items-center justify-center gap-1 w-full bg-[#7fc241] hover:bg-[#7fc241]/90 rounded-lg transition-colors" onClick={handleUnlock}>
                {isModalLoading ? <ClipLoader size={20} color="#121212" /> : <> 
                <span className="[font-family:'Inter',Helvetica] font-semibold text-[#121212] text-lg tracking-[0]">
                Unlock Full Course Now
                </span>
                <ArrowRightIcon className="text-black" size={20}  strokeWidth={2.5}/>
                </>}
            </button>

            <div className="flex items-center justify-center gap-3 w-full">
                <div className="inline-flex items-center gap-1.5">
                <StarIcon className="w-3.5 h-3.5 fill-current text-[#F59E0B]" />
                <span className="[font-family:'Inter',Helvetica] text-sm tracking-[0] leading-[14px]">
                    <span className="font-bold text-[#ffffffb2]">4.7 </span>
                    <span className="font-normal text-[#ffffffb2]">
                    Course Rating
                    </span>
                </span>
                </div>

                <div className="w-2 h-2 bg-[#ffffff80] rounded-lg" />

                <div className="inline-flex items-center gap-1.5">
                <UsersIcon className="w-4 h-4 text-[#ffffffb2]" />
                <span className="[font-family:'Inter',Helvetica] font-normal text-[#ffffffb2] text-sm tracking-[0] leading-[14px]">
                    <span className="font-bold">1370</span>
                    <span> Learners</span>
                </span>
                </div>
            </div>
            </div>
        </section>

        <div className="w-full h-px bg-white/10" />

        <section className="flex flex-col items-start gap-4 w-full">
            <h2 className="[font-family:'Inter',Helvetica] font-bold text-white text-xl tracking-[0] leading-5">
            Get Benefits Like
            </h2>

            <div className="flex flex-col items-start gap-5 w-full">
            {benefits?.map((benefit, index) => (
                <div key={index} className="flex items-center gap-2 w-full">
                <div className="bg-[#2bbd13] rounded-full p-1 flex-shrink-0">
                    <CheckIcon className="h-3 w-3 flex-shrink-0 font-bold text-[#102D47]" strokeWidth={4}/>
                </div>
                <p className="flex-1 [font-family:'Inter',Helvetica] font-normal text-white text-[14px] tracking-[0] leading-[19.6px]">
                    {benefit}
                </p>
                </div>
            ))}
            </div>
        </section>

        {courseModule?.course_outcome?.length > 0 && <div className="w-full h-px bg-white/10" />}

        {courseModule?.course_outcome?.length > 0 && <section className="flex flex-col items-start gap-4 w-full">
            <h2 className="[font-family:'Inter',Helvetica] font-bold text-white text-xl tracking-[0] leading-5">
            Course Outcomes
            </h2>

            <div className="flex flex-col items-start gap-4 w-full">
            {courseModule?.course_outcome?.map((outcome, index) => (
                <div key={index} className="inline-flex items-center gap-3">
                <CheckIcon className="w-4 h-4 text-[#2bbd13] flex-shrink-0" />
                <span className="[font-family:'Inter',Helvetica] font-normal text-white text-[14px] tracking-[0] leading-[19.6px]">
                    {outcome?.slice(2)}
                </span>
                </div>
            ))}
            </div>
        </section>}

        <div className="w-full h-px bg-white/10" />
            <div className="text-[24px] font-bold text-white">
                Real Learners, Real Outcomes
            </div>
            <SuccessStory />
        </div>
    </div>
  );
};

export default DesktopOnboardingOverview;
